import React from 'react'
import { Dropdown, Number } from 'components'

export default class DropdownWithCustomInput extends React.Component {
  state = {
    custom: this.props.isCustom,
  }

  toggle = () =>
    this.setState(prevState => {
      if (!prevState.custom) {
        this.props.handleCustomInput(this.props.customValue)
      }
      if (prevState.custom) {
        this.props.handleCustomInput(null)
      }
      return { custom: !prevState.custom }
    })

  switch = label => (
    <div className="dropdownWithCustomInput">
      <span>{label}</span>
      <a onClick={() => this.toggle()}>
        {this.state.custom ? 'Choose' : 'Custom'}
      </a>
    </div>
  )

  render() {
    const {
      customLabel,
      customMessage,
      customValue,
      handleCustomInput,
      label,
      message,
      menuItems,
      defaultItem,
      handleUpdate,
    } = this.props
    return (
      <div>
        {this.state.custom ? (
          <Number
            label={this.switch(customLabel)}
            message={customMessage}
            value={customValue}
            min={0}
            max={101}
            handleUpdate={handleCustomInput}
          />
        ) : (
          <Dropdown
            label={this.switch(label)}
            message={message}
            menuItems={menuItems}
            defaultItem={defaultItem}
            handleUpdate={handleUpdate}
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/DropdownWithCustomInput.js